<template>
    <div>
        <b-button class="mt-2" @click="showEmailModal" v-if="$hasPermission('reservation.notification.send')">Enviar Nueva notificación</b-button>
        <AjaxTable id="reservations-mail-history-list" stacked="lg" :filters="filtersClean" :columns="modelColumns" resource="reservations-mail-history" responsive>
            <template #cell(change)="row">
                <span v-for="(change,i) in row.item.changes" :key="`${modelId}-${i}`">
                    {{change}}
                    <br />
                </span>
            </template>
        </AjaxTable>
        <b-overlay :show="loading" no-wrap rounded></b-overlay>
        <b-modal hide-footer size="md" id="modal-send-email" ref="modal-send-email" title="Enviar notificación">
            <FormNotification
            :listPayments="listPayments"
            :listTemplates="listTemplates"
            :selected="selected"
            />
        </b-modal>
    </div>
</template>

<script>
import AjaxTable from "../../../helpers/AjaxTable.vue";
import api from "../../../../api.js";
import FormNotification from "./Form.vue";
import {mapState} from "vuex";

export default {
    components: { AjaxTable, FormNotification },
    props: {
        filters: {
            default:()=>({}),
            type: Object,
            required: false
        },
        selected:{
            type:Object,
            required:false,
            default:()=>({})
        }
    },
    data() {
        return {
            loading:false,
            modelColumns: [
                { key: "id", label: "ID del envío" },
                { key: "status", label: "Estado" },
                { key: "creationDatetime", label: "Fecha" },
                { key: "user", label: "Usuario" },
                { key: "type", label: "Tipo" },
                { key: "notificationType", label: "Tipo de notificación" },
                { key: "dataSource", label: "Data source" },
                { key: "destination", label: "Destino" },
                { key: "tags", label: "Tags" },
            ],
            listTemplates:[],
            listPayments:[]
        };
    },
    methods: {
        showEmailModal() {
            this.$refs["modal-send-email"].show()
        },
        getPayments(){
           return api(this)
            .get(`reservations/${this.viewModel.id}/payments`)
            .then( res => {
                this.listPayments = res.data.payments;
            })
            .catch(this.$root.handleRequestError);
        },
        getTemplates(){
            return api(this)
            .get(`/notifications/templates`)
            .then((res) => {
                this.listTemplates = res.data;
            })
            .catch(this.$root.handleRequestError)
            .finally(() => {
                this.loading = false;
            })
        },
        async fetch(){
            this.loading = true
            await this.getPayments();
            await this.getTemplates();
            this.loading = false

        }
    },
    computed: {
        ...mapState("reservation", ["viewModel"]),
        filtersClean() {
            let filters   = {id: this.viewModel.id}
            let optionalFilters  = {...this.filters}
            try{
                if((Object.keys(optionalFilters).length)>0 && 'only' in optionalFilters){
                    Object.assign(filters,optionalFilters);
                }
            }catch(err){
                filters   = {id: this.viewModel.id};
            }

            return filters;
        }
    },
    mounted() {
        this.fetch();
    },
};
</script>

<style >
#reservations-history-list tr td {
    /*white-space: pre !important;*/
}
</style>
